import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import './PrivacyPolicyModal.css';

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="privacy-policy-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="privacy-policy-modal-title"
      onClick={onClose}
    >
      <div className="privacy-policy-modal" onClick={(e) => e.stopPropagation()}>
        <div className="privacy-policy-modal-header">
          <h2 id="privacy-policy-modal-title">Política de Privacidad</h2>
          <button
            type="button"
            className="privacy-policy-modal-close"
            aria-label="Cerrar política de privacidad"
            onClick={onClose}
          >
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        </div>
        <div className="privacy-policy-modal-body">
          <PrivacyPolicyPage embedded />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PrivacyPolicyModal;
